import { CartTableHeader } from "../../../Constant";

export const CartTableHead = () => {
  return (
    <thead>
      <tr>
        {CartTableHeader.map((items, i) => (
          <th key={i}>{items}</th>
        ))}
      </tr>
    </thead>
  );
};
